import { render, staticRenderFns } from "./V10Main.vue?vue&type=template&id=21dc2fe6&"
import script from "./V10Main.vue?vue&type=script&lang=js&"
export * from "./V10Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports